/// <reference path="../../common/modals/modals.ts" />
/// <reference path="../../crm/entitieslist/entitieslist.ts" />

namespace OfficeGuy.Apps {
    export class Salaries {
        static RefreshSelection() {
            var IsChecked = OfficeGuy.CRM.EntitiesList.SelectedEntities_GetSelected().length != 0;
            if (IsChecked)
                $(".entitiesdropdown-selected").clearQueue().fadeIn();
            else
                $(".entitiesdropdown-selected").clearQueue().fadeOut();
        }

        static DeleteSelection() {
            OfficeGuy.Modals.ShowConfirmDialog({
                Message: "האם ברצונך למחוק את תלושי השכר שסומנו?<br />לתשומת הלב! תלושים שאושרו, אינם ניתנים למחיקה.<br />מחיקת תלושים אינה ניתנת לביטול/שחזור.",
                Title: "מחיקת תלושי שכר",
                ConfirmEvent: function () {
                    OfficeGuy.Modals.ShowHTMLGetDialog({
                        URL: "/salaries/deletesalaries/",
                        Method: 'POST',
                        Data: { IDs: OfficeGuy.CRM.EntitiesList.SelectedEntities_GetSelected() },
                        ReplaceModal: true,
                        ConvertToAjax: true
                    });
                },
                ConfirmClass: "og-button-color-danger"
            });
            return false;
        }

        static ApproveSelection(Email) {
            OfficeGuy.Modals.ShowConfirmDialog({
                Message: Email ? "האם ברצונך לאשר את תלושי השכר שסומנו?<br />לאחר האישור המערכת תשלח דוא\"ל המכיל את תלוש השכר לכל אחד מהעובדים שסומנו." : "האם ברצונך לאשר את תלושי השכר שסומנו?",
                Title: "אישור תלושי שכר",
                ConfirmEvent: function () {
                    OfficeGuy.Modals.ShowHTMLGetDialog({
                        URL: "/salaries/approvesalaries/",
                        Method: 'POST',
                        Data: { IDs: OfficeGuy.CRM.EntitiesList.SelectedEntities_GetSelected(), Email: Email },
                        ReplaceModal: true,
                        ConvertToAjax: true
                    });
                }
            });
            return false;
        }
    }
}
